import LivestreamProductMapperInterface from '../interface-adapters/LivestreamProductMapperInterface';
import LivestreamProductRepositoryInterface from '../interface-adapters/LivestreamProductRepositoryInterface';
import LivestreamProductMapper from '../mappers/LivestreamProductMapper';
import LivestreamProductRepository from '../repositories/LivestreamProductRepository';
import GetLivestreamProductBydIdUseCase from '../use-cases/GetLivestreamProductBydIdUseCase';

export default class LivestreamProductFactory {
    private constructor() {}

    private static repo: LivestreamProductRepositoryInterface;
    private static mapper: LivestreamProductMapperInterface;
    private static getLivestreamProductBydIdUseCase: GetLivestreamProductBydIdUseCase;

    public static makeRepo() {
        if (!this.repo) {
            this.repo = new LivestreamProductRepository();
        }

        return this.repo;
    }

    public static makeMapper() {
        if (!this.mapper) {
            this.mapper = new LivestreamProductMapper();
        }

        return this.mapper;
    }

    public static makeGetLivestreamBydIdUseCase() {
        if (!this.getLivestreamProductBydIdUseCase) {
            this.getLivestreamProductBydIdUseCase = new GetLivestreamProductBydIdUseCase();
        }

        return this.getLivestreamProductBydIdUseCase;
    }
}
